import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    schools: [],
    school: {}
  },
  mutations: {
    index(state, payload) {
      state.schools = payload
    },
    show(state, payload) {
      state.school = payload
    }
  },
  actions: {
    index({ commit }) {
      axios.get(`${ENV.API_URL}/api/schools`).then((res) => {
        commit('index', res.data)
      })
    },
    show({ commit }, payload) {
      axios.get(`${ENV.API_URL}/api/schools/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({ commit }, payload) {
      axios.post(`${ENV.API_URL}/api/schools`, payload).then((res) => {
        commit('show', res.data)
      })
    },
    update({ commit }, payload) {
      axios.put(`${ENV.API_URL}/api/schools/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
      })
    }
  },
  getters: {
    schools: state => {
      return state.schools
    },
    school: state => {
      return state.school
    }
  },
  modules: {}
}
